<template>
  <v-container grid-list-lg fill-height v-if="projectReader.ready">
    <v-layout column>
      <v-layout column justify-center align-center v-if="!isProjectsEmpty">
        <v-flex shrink>
          <img src="../../../public/img/kingdom-waiting.png" style="height:30vh"
        /></v-flex>
        <v-flex class="headline font-weight-black" shrink>
          Create New Goal</v-flex
        >
        <v-flex class="font-weight-light pa-0" shrink>
          Start tracking your progress
        </v-flex>

        <br />
        <v-flex shrink
          ><v-btn color="primary" @click="onNewProject">
            Create New</v-btn
          ></v-flex
        >
      </v-layout>
      <v-layout shrink wrap>
        <v-flex xs12 md6 v-for="entry in projects" :key="entry[0]">
          <ProjectCard
            :project="entry[1]"
            :timer="timerReader.getByProjectId(entry[0])"
            :projectId="entry[0]"
            :recordCache="recordCacheReader.getByProjectId(entry[0])"
          />
        </v-flex>
      </v-layout>

      <v-layout shrink v-if="isProjectsEmpty" align-end justify-end>
        <v-flex shrink>
          <v-btn @click="onNewProject" color="primary" fab flat>
            <v-icon small>fas fa-plus</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
    <ProjectEditorDialog creation :dialogController="projectDialogController" />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ProjectCard from "@/components/ProjectCard";
import ProjectEditorDialog from "@/components/ProjectEditorDialog";
export default {
  computed: {
    ...mapState([
      "projectReader",
      "timerReader",
      "recordCacheReader",
      "projectDialogController"
    ]),
    projects() {
      return Object.entries(this.projectReader.data).sort((a, b) => {
        return a[1].index - b[1].index;
      });
    },
    isProjectsEmpty() {
      return this.projects.length > 0;
    }
  },
  components: {
    ProjectCard,
    ProjectEditorDialog
  },
  methods: {
    onNewProject() {
      this.projectDialogController.open(this.projectReader.create(), {});
    }
  }
};
</script>
